'use client'
import { UseClientModelContext } from '@mercadoni/sinister/dist/cjs/client'
import { Button } from 'antd'
import { useCallback, useEffect, useState } from 'react'

import { useDownloadTheAppContext } from '@/context/DownloadTheAppContext'
import getLocale from '@/stores/locales'
import navigateToTheApp from '@/utils/navigateToTheApp'
import variables from '../../utils/style.config'
import { DrawerStyled } from './DrawerStyled'

const AppDrawer = () => {
  const { openDownload, cancelDownload, isEnabledToDownload, storeData } =
    useDownloadTheAppContext()

  const [visible, setVisible] = useState(false)
  const { theme } = UseClientModelContext()
  const { suggestOpenTheApp: copy = {} } = getLocale() || {
    suggestOpenTheApp: {
      description: '',
      title: '',
      buttons: {
        cancel: '',
        download: '',
      },
    },
  }

  useEffect(() => setVisible(isEnabledToDownload), [isEnabledToDownload])

  const onCancel = useCallback(() => {
    cancelDownload()
    setVisible(false)
  }, [cancelDownload])

  const onOpen = useCallback(async () => {
    await openDownload()
    setVisible(false)
    navigateToTheApp(storeData)
  }, [openDownload, storeData])

  return (
    <DrawerStyled
      placement="bottom"
      height={170}
      onClose={onCancel}
      closable={false}
      mask={false}
      open={visible}
      zIndex={999999}
      style={variables.stylesObjByClient(theme)}
    >
      <p className="drawer-description">{copy?.description}</p>
      <p className="drawer-title">{copy?.title}</p>
      <div className="drawer-buttons">
        <Button ghost type="primary" onClick={onCancel}>
          {copy?.buttons?.cancel}
        </Button>
        <Button type="primary" onClick={onOpen}>
          {copy?.buttons?.download}
        </Button>
      </div>
    </DrawerStyled>
  )
}

const SuggestOpenTheAppDrawer = () => {
  return <AppDrawer />
}

export default SuggestOpenTheAppDrawer
